<template>
    <div id="coupons">
        <AppBreadCrumb :paths="[{ title: $t('coupon.coupons') }]" :select="true">
            <a-button v-b-modal.coupon-form class="actionButtonBreadcrumb" @click="() => (modalVisible = true)">
                <md-icon>add</md-icon>
                {{ $t("coupon.add") }}
            </a-button>
            <a-button
                v-b-modal.multi-coupon-form
                class="actionButtonBreadcrumb"
                @click="() => (multiCreateModalVisible = true)"
            >
                <md-icon>add</md-icon>
                Multi Coupon
            </a-button>
        </AppBreadCrumb>
        <a-card class="">
            <div class="content">
                <div class="filters">
                    <a-tag
                        color="blue"
                        closable
                        v-for="partner in filteredPartners"
                        @close="removePartnerFromFilter(partner)"
                        :key="partner"
                    >
                        <a-icon type="filter" class="mr-2" />
                        {{ partner }}
                    </a-tag>
                </div>
                <div class="multi-action-bar" v-if="hasSelected">
                    <span> {{ selectedRowKeys.length }} coupon selected </span>
                    <div class="actions">
                        <div class="action" @click="selectedRowKeys = []">Unselect All</div>
                        <div class="action" @click="downloadAsCSV">Download</div>
                    </div>
                </div>
                <a-table
                    bordered
                    :columns="cols"
                    :dataSource="filteredData"
                    :pagination="{ pageSize: 20 }"
                    class=""
                    rowKey="_id"
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    @change="tableChange"
                >
                    <div :slot="'endDate'" slot-scope="data, item">
                        {{ new Date(`${item.endDate}`) | dateShorted }}
                    </div>
                    <div :key="'partnerNameSlot-' + $i18n.locale" slot="partnerNameSlot" slot-scope="data, item">
                        <div class="partner-name">
                            {{ $_.get(item, "partner.name") }}
                            <div class="btnFilter" @click="addPartnerToFilter($_.get(item, 'partner.name'))">
                                <a-icon type="filter" />
                            </div>
                        </div>
                    </div>
                    <div :slot="'actionsSlot'" slot-scope="data, item">
                        <div class="d-flex w-100 justify-content-center m-0 p-0">
                            <a-button class="actionButton d-flex align-items-center" @click="edit(item._id)">
                                <span style="margin-right: 16px; display: block">{{ $t("message.edit") }}</span>
                                <ActionEdit />
                            </a-button>
                            <a-button class="actionButton d-flex align-items-center" @click="del(item._id)">
                                <span style="margin-right: 16px; display: block">{{ $t("message.deleteField") }}</span>
                                <ActionDelete />
                            </a-button>
                        </div>
                    </div>
                </a-table>
            </div>
        </a-card>
        <Modal2
            v-if="modalVisible"
            :title="editId ? $t('message.update') : $t('coupon.add')"
            @ok="!editId ? handleSave() : update()"
            @cancel="resetForm()"
            :cancelText="$t('message.cancel')"
            :okText="editId ? $t('message.update') : $t('message.save')"
        >
            <div>Kupon Adı</div>
            <a-input autocomplete="off" trim type="text" v-model="form.name" />
            <div>Kupon Kod <span style="font-size: 12px">(Boş Bırakırsanız Rastgele Oluşturur)</span></div>
            <a-input autocomplete="off" trim type="text" v-model="form.code" />
            <div>Mail</div>
            <a-input autocomplete="off" trim type="text" v-model="form.email" />
            <div>Telefon</div>
            <div class="d-flex flex-row align-items-center justify-content-between m-0 p-0">
                <!-- <vue-country-code
                    class="col-4 m-0 p-0"
                    :enabledCountryCode="true"
                    @onSelect="onSelect($event)"
                    :defaultCountry="!!user && !!user.lastGeoLocation ? user.lastGeoLocation : 'TR'"
                    style="height: 31px"
                /> -->
                <a-input
                    class="m-0 p-2"
                    v-model="form.phone"
                    :placeholder="$t('message.phone')"
                    autocomplete="off"
                    trim
                    type="text"
                    v-mask="'##########'"
                />
            </div>
            <div>İndirim (%)</div>
            <a-input type="number" v-model="form.discount" />
            <div>Kullanım Limiti</div>
            <a-input type="number" v-model="form.limit" />
            <div>Bitiş Tarihi</div>
            <a-date-picker style="width: 100%" v-model="form.endDate" />
        </Modal2>

        <a-modal
            v-model="multiCreateModalVisible"
            :key="'vtable-' + renderCount"
            title="Multi Coupon Creator"
            centered
            @ok="handleSaveMultiCoupon()"
            @cancel="multiCreateModalVisible = false"
            :cancelText="$t('message.cancel')"
            :okText="$t('message.save')"
        >
            <MultiCreateCoupon v-model="multiCouponFormData" />
        </a-modal>
    </div>
</template>

<script>
import request from "../../../utils/request";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import ActionEdit from "../../../components/svg/ActionEdit.vue";
import ActionDelete from "../../../components/svg/ActionDelete.vue";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import VueTheMask from "vue-the-mask";
import log2 from "../../../utils/log2";
import { mapState } from "vuex";
import MultiCreateCoupon from "./MultiCreateCoupon.vue";
import { tableSorter } from "../../../utils/utils";
import * as _ from "lodash";
import Modal2 from "../../../components/common/Modal2.vue";
Vue.use(VueTheMask);
Vue.use(VueCountryCode);
const log = log2("Coupons");

export default {
    name: "Coupons",
    components: { ActionDelete, ActionEdit, AppBreadCrumb, VueTheMask, MultiCreateCoupon, Modal2 },
    data() {
        return {
            filteredPartners: [],
            selectedRowKeys: [],
            currentSort: {
                columnKey: "isOnline",
                order: "ascend",
            },
            cols: [
                {
                    title: this.$t("coupon.code"),
                    dataIndex: "code",
                },
                {
                    title: this.$t("coupon.discount"),
                    dataIndex: "discount",
                    ...tableSorter("discount", "number", this.currentSort),
                },
                {
                    title: this.$t("coupon.endDate"),
                    dataIndex: "endDate",
                    scopedSlots: { customRender: "endDate" },
                    ...tableSorter("endDate", "date", this.currentSort),
                },
                {
                    title: this.$t("coupon.name"),
                    dataIndex: "partner.name",
                    ...tableSorter("partner.name", "string", this.currentSort),
                    scopedSlots: { customRender: "partnerNameSlot" },
                },
                {
                    title: this.$t("coupon.email"),
                    dataIndex: "partner.email",
                },
                {
                    title: this.$t("coupon.phone"),
                    dataIndex: "partner.phone",
                },
                {
                    title: this.$t("coupon.limit"),
                    dataIndex: "limit",
                    ...tableSorter("discount", "number", this.currentSort),
                },
                {
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                    width: "10%",
                },
            ],
            data: [],
            editId: null,
            internationalCallingCode: "90",
            renderCount: 0,
            form: {
                name: null,
                email: null,
                phone: null,
                discount: 0,
                limit: 0,
                endDate: null,
                code: null,
            },
            loading: false,
            formLayout: "horizontal",
            modalVisible: false,
            multiCreateModalVisible: false,
            multiCouponFormData: {
                name: "",
                discount: 10,
                count: 10,
                codeLength: 4,
                endDate: null,
                prefix: null,
            },
        };
    },
    computed: {
        ...mapState({
            loggedUser: (state) => state.auth.adminUser,
            adminUser: (state) => state.auth.adminUser,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
        filteredData() {
            return this.data.filter((x) => {
                if (this.filteredPartners.length === 0) {
                    return true;
                } else {
                    return this.filteredPartners.includes(_.get(x, "partner.name"));
                }
            });
        },
    },
    methods: {
        downloadAsCSV() {
            const csv = this.filteredData.map((x) => {
                return {
                    code: x.code,
                    discount: x.discount,
                    partnerName: x.partner.name,
                    limit: x.limit,
                    endDate: x.endDate,
                };
            });
            const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
            const header = Object.keys(csv[0]);
            let csvContent = csv.map((row) =>
                header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(",")
            );
            csvContent.unshift(header.join(","));
            csvContent = csvContent.join("\r\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "coupons.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        removePartnerFromFilter(partner) {
            this.filteredPartners = this.filteredPartners.filter((p) => p !== partner);
        },
        addPartnerToFilter(partner) {
            this.filteredPartners = _.uniq([...this.filteredPartners, partner]);
        },
        tableChange(pagination, filters, sorter) {
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;

            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.$forceUpdate();
            }
        },
        onSelectChange(selectedRowKeys) {
            console.log("selectedRowKeys changed: ", selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        async handleSave() {
            this.loading = true;
            await this.create();
            this.loading = false;
            this.resetForm();
        },
        async handleSaveMultiCoupon() {
            this.loading = true;
            await this.multiCreate();
            this.loading = false;
            this.multiCreateModalVisible = false;
            this.multiCouponFormData = {
                name: "",
                discount: 10,
                count: 10,
                codeLength: 4,
                endDate: null,
                prefix: null,
            };
        },
        edit(id) {
            this.editId = id;
            const updatingItem = this.data.filter((coupon) => coupon._id === id)[0];
            let { name, email, phone } = _.get(updatingItem, "partner");
            log("edit continue 1", { name, email, phone });
            let { discount, limit, endDate } = updatingItem;
            log("edit continue 2", { discount, limit, endDate });

            this.form = {
                ...{},
                name,
                email,
                phone,
                discount,
                limit,
                endDate,
            };
            log("edit continue 3", this.form);
            this.modalVisible = true;
        },
        del(id) {
            this.$dialog
                .confirm(this.$t("message.deleteDepartmentQuestion"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    this.remove(id)
                        .then((x) => {
                            this.$toasted.show(this.$t("coupon.couponDeleted"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .catch((err) => {
                            log.error(err.response, err.message);
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            this.$toasted.error(errMsg, {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        });
                });
        },
        onSelect(value) {
            log("onSelect", value);
            this.internationalCallingCode = value.dialCode;
        },
        resetForm() {
            this.modalVisible = false;
            this.form = {
                name: null,
                email: null,
                phone: null,
                discount: 0,
                limit: 0,
                endDate: null,
            };
            this.editId = null;
        },
        async create() {
            try {
                log("create started", this.form);
                const { data } = await request.post("coupon", this.form);
                log("create started", data);
                this.data.push(data);
            } catch (e) {}
        },
        async multiCreate() {
            try {
                log("multiCreate started", this.multiCouponFormData);
                const { data } = await request.post("coupon/multi", this.multiCouponFormData);
                log("multiCreate finished", data);

                this.data = _.orderBy([...this.data, ...data], ["createdAt"], ["desc"]);
            } catch (e) {}
        },
        async update() {
            this.loading = true;
            try {
                const { data } = await request.patch("coupon/" + this.editId, this.form);
                this.data = this.data.map((x) => (x._id === id ? data : x));
            } catch (e) {
            } finally {
                this.loading = false;
                const updatingItem = this.data.filter((coupon) => coupon._id === this.editId)[0];
                const indexOfUpdatingItem = this.data.findIndex((coupon) => coupon._id === this.editId);
                log("updated row", this.data);
                log("updated row", this.data[indexOfUpdatingItem]);
                this.data[indexOfUpdatingItem] = {
                    ...updatingItem,
                    discount: this.form["discount"],
                    limit: this.form["limit"],
                    endDate: this.form["endDate"],
                };
                this.data[indexOfUpdatingItem].partner = {
                    name: this.form["name"],
                    email: this.form["email"],
                    phone: this.form["phone"],
                };
                log("updated row", this.data[indexOfUpdatingItem]);
                this.resetForm();
            }
        },
        async list() {
            try {
                const { data } = await request.get("coupon");
                this.data = data;
            } catch (e) {}
        },
        async get(id) {
            try {
                const { data } = await request.get("coupon/" + id);
                this.form = data;
                this.data = this.data.map((x) => (x._id === id ? data : x));
            } catch (e) {}
        },
        async remove(id) {
            try {
                await request.delete("coupon/" + id);
                this.data = this.data.filter((x) => x._id !== id);
            } catch (e) {}
        },
    },
    mounted() {
        this.list();
    },
    beforeMount() {
        const isAccessEnabled =
            this.loggedUser.isFullAccess || this.loggedUser.approvedPages.some((page) => page.page === "coupons");
        if (!isAccessEnabled) {
            this.$router.push("/denied");
        }
    },
};
</script>

<style lang="scss">
#coupons {
    .ant-table-thead > tr > th {
        color: white;
        background: #1e1e2dd9;
        border-radius: unset !important;
    }

    .vue-country-select .current {
        height: 26px !important;
    }

    .ant-table-thead > tr:first-child > th {
        border-top-left-radius: 4px;
        padding-left: 15px;
    }

    .ant-table-row {
        td {
            padding: 0px 5px;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .partner-name {
        display: flex;
        gap: 5px;

        .btnFilter {
            visibility: hidden;
        }
    }

    .partner-name:hover {
        .btnFilter {
            visibility: visible;
            cursor: pointer;
        }
    }

    .multi-action-bar {
        display: flex;
        justify-content: space-between;
        background: #1e1e2dd9;
        color: white;
        align-items: center;
        padding: 10px;

        .actions {
            display: flex;
            gap: 5px;

            .action {
                padding: 5px;
                cursor: pointer;
                user-select: none;
                border: 1px solid transparent;

                &:hover {
                    border: 1px solid white;
                }
            }
        }
    }
}
</style>
